import {Manager} from "../core";

export const get = async () => {
	try {
		const {data} = await Manager.request(
			'get',
			'/admin/config/list.php',
		);

		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.settings.get', err)
	}
}

export const update = async (payload: any) => {
	try {
		const {data} = await Manager.request(
			'post',
			'/admin/config/update.php',
			payload
		);

		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.settings.update', err)
	}
}
